import { getCurrentTimeInTimezone } from 'common/services/dateService'

const SLOT_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/
const SLOT_TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/
const WALL_CLOCK_FORMAT = 'YYYY-MM-DD HH:mm:ss'
const DAY_FORMAT = 'YYYY-MM-DD'

type SlotStart = {
  date: string
  startTime?: string
  timeZone?: string
}

// Compares site wall-clock digits; avoids dayjs.tz(string) parsing, which drifts around DST.
export const isSlotStartInPast = ({ date, startTime, timeZone }: SlotStart): boolean => {
  if (!SLOT_DATE_PATTERN.test(date) || !startTime || !SLOT_TIME_PATTERN.test(startTime)) {
    return false
  }
  // Without the site zone, keep delete closed rather than trust the viewer clock.
  if (!timeZone) return true
  const seconds = startTime.length === 5 ? ':00' : ''
  const slotStart = `${date} ${startTime}${seconds}`
  return getCurrentTimeInTimezone(timeZone).format(WALL_CLOCK_FORMAT) > slotStart
}

export const isSiteDayInPast = (date: string, timeZone?: string): boolean => {
  if (!timeZone || !SLOT_DATE_PATTERN.test(date)) return false
  return date < getCurrentTimeInTimezone(timeZone).format(DAY_FORMAT)
}
